import { useState, useCallback } from 'react';
import { financialApi } from '../utils/financialApi';
import { extractApiUserMessage } from '../utils/api';

// Hook for realtime discount validation
export const useDiscountValidation = () => {
  const [isValidating, setIsValidating] = useState(false);
  const [validationResult, setValidationResult] = useState(null);
  const [validationError, setValidationError] = useState(null);

  const validateDiscount = useCallback(async (originalPrice, discountAmount, discountPercent) => {
    // Basic pre-validation checks
    if (!originalPrice || originalPrice <= 0) {
      setValidationResult(null);
      return;
    }
    
    if ((!discountAmount && !discountPercent) || (discountAmount <= 0 && discountPercent <= 0)) {
      setValidationResult(null);
      return;
    }

    try {
      setIsValidating(true);
      setValidationError(null);

      const res = await financialApi.validateDiscount({
        original_price: Number(originalPrice),
        discount_amount: discountAmount !== undefined ? Number(discountAmount) : undefined,
        discount_percent: discountPercent !== undefined ? Number(discountPercent) : undefined,
      });
      
      const validationData = res?.data?.validation || res?.validation;
      setValidationResult(validationData);
      
    } catch (error) {
      console.error('Failed to validate discount:', error);
      setValidationError(extractApiUserMessage(error) || 'خطا در اعتبارسنجی تخفیف');
      setValidationResult(null);
    } finally {
      setIsValidating(false);
    }
  }, []);

  const clearValidation = useCallback(() => {
    setValidationResult(null);
    setValidationError(null);
  }, []);

  return {
    validateDiscount,
    isValidating,
    validationResult,
    validationError,
    clearValidation
  };
};
